import { GetTransactionModel } from "@factory/model/query-model-transaction";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { transactionFormDefault } from "./form.default";
import { TransactionFormSchema } from "./form.rule";

export const useFormDefaultTransaction = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetTransactionModel | undefined) => {
    return !cachedValue
      ? transactionFormDefault
      : ({
          tenant: cachedValue.tenant,
          branch: cachedValue.branch,
          userCode: cachedValue.user_code,
          cardSeries: cachedValue.card_series,
          reward: cachedValue.reward,
          campaign: cachedValue.campaign,
          action: cachedValue.action,
          amount: cachedValue.amount,
          points: cachedValue.points,
          stamp: cachedValue.stamp,
          remarks: cachedValue.remarks,
          branchName: cachedValue.branch_name,
          customerName: `${cachedValue.first_name} ${cachedValue.last_name}`,
          campaignName: cachedValue.campaign_name,
          cardAlias: cachedValue.card_alias,
          rewardEventName: cachedValue.reward_name,
          voidedBy: cachedValue.voided_by,
          voidedFirstName: cachedValue.voided_first_name,
          voidedLastName: cachedValue.voided_last_name,
          voidedAt: cachedValue.voided_at,
          receiptNumber: cachedValue.receipt_number,
        } as TransactionFormSchema);
  };

  return {
    getDefault,
  };
};
